var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificatePrintBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.341,
    height: 74.107,
    viewBox: "0 0 82.341 74.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-print",
    d: "M75.131,27.012H17.493A12.361,12.361,0,0,0,5.141,39.363v24.7H21.61V80.534h49.4V64.065H87.482v-24.7A12.361,12.361,0,0,0,75.131,27.012ZM62.78,72.3H29.844V51.714H62.78ZM75.131,43.48a4.117,4.117,0,1,1,4.117-4.117A4.1,4.1,0,0,1,75.131,43.48ZM71.014,6.427H21.61V22.895h49.4V6.427Z",
    transform: "translate(-5.141 -6.427)",
    fill: "#ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificatePrintBtn);
export default __webpack_public_path__ + "static/media/certificate_print_btn.2a149e29.svg";
export { ForwardRef as ReactComponent };